import React, { useEffect } from "react";
import { $apiV1 } from "../../config/api";
import { APP_VERSION } from "../../config/version";
import { NotificationList } from "../notification/NotificationList";
import { useNotification } from "../notification/useNotification";

// Fixed id so a repeated check can never stack duplicate toasts.
const UPDATE_NOTIFICATION_ID = "app-version-update";

// Asks the backend whether a newer build has been deployed than the one the
// user is currently running. The backend holds the latest version and does the
// comparison; if it reports `update_available`, we surface a persistent toast
// with an "Update" button that hard-reloads onto the fresh build.
//
// This complements the service-worker auto-reload: the SW reloads tabs that
// were open across a deploy, while this catches long-lived tabs that missed the
// SW update and gives the user an explicit, non-disruptive way to update.
const VersionUpdateNotifier = () => {
  const { notifications, addNotification, removeNotification } = useNotification();

  useEffect(() => {
    let cancelled = false;

    $apiV1
      .post("/app-version/check", { version: APP_VERSION })
      .then((response) => {
        if (cancelled) return;
        if (response?.data?.update_available) {
          addNotification("A new version of the app is available.", "info", {
            id: UPDATE_NOTIFICATION_ID,
            actionLabel: "Update",
            // duration 0 → stays until the user updates or dismisses it.
            duration: 0,
            onAction: () => window.location.reload(),
          });
        }
      })
      .catch(() => {
        // Version check is best-effort — never block or alert the user if the
        // endpoint is unreachable.
      });

    return () => {
      cancelled = true;
    };
  }, [addNotification]);

  return <NotificationList notifications={notifications} onClose={removeNotification} />;
};

export default VersionUpdateNotifier;
